import React from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { baseUrlGet } from '../../common';
import "./PhotoDocumentation.scss";
import "./PhotoSeriesEl.scss";


let PhotoSeriesEl = ({ phSer }) => {
  const hrGet = () => {
    const serType = (phSer.sType == 'fotografije' ? 'ph' : 'nk');
    return '/g/' + phSer.group + '/photo-series/' + serType + '/' + phSer.slug;
  }
  const urlBase = baseUrlGet();
  const fold = phSer.fold;
  const imPGet = (photo) => {
    const imP = urlBase + '/stat-u/photo-series/' + fold + '/' + photo;  
    return imP;
  };

  let photoN = [];
  if (phSer.hasOwnProperty('represent') && phSer.represent.hasOwnProperty('middle')) {
    photoN.push(phSer.represent.middle);    
  }
  const maxN = Math.min(4, phSer.photos.length);
  for (let i = 0; i < maxN; i++) {
    const ph = phSer.photos[i].small;
    if (!photoN.includes(phSer.photos[i].name) && !photoN.includes(phSer.photos[i].middle) && !photoN.includes(phSer.photos[i].small)) {
      photoN.push(ph);      
    }
    if (photoN.length >= maxN) {
      break;      
    }    
  }

  let phLi = [];
  for (let i = 0; i < photoN.length; i++) {
    phLi.push(<Col lg={i > 0 ? 2 : 3} key={ 'p-col-' + i }>
      <Link to={hrGet()} >
        <img src={ phSer.imPGet(photoN[i]) } alt={ phSer.name } />
      </Link>
    </Col>);    
  }
  
  return (
    <Container sm={{ span: 12 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }} className="ph-ser-el-cont">
      <Row>
        <Col lg="2">
          <Link to={hrGet()}>
            { phSer.name }
          </Link>                            
        </Col>
        { phLi }
      </Row>
    </Container>
  );
} 

export default PhotoSeriesEl;
